export function EclientsABP() {
    return (
        <section className="clients-main-section">
            <div className="tittle-clients">
                <h2>Clients</h2>
            </div>
            <div className="clients-main-box">
                <div className="client">
                    <img alt="city construcciones" src="../images/logos/clientsNoBc/turaInmobiliaria-removebg.png" width={150}></img>
                </div>
                <div className="client">
                    <img alt="Agropia" src="../images/logos/clientsNoBc/Agropiga-removebg.png" width={150}></img>
                </div>
                <div className="client">
                    <h4>Boom comer CLN</h4>
                </div>
                <div className="client">
                    <img alt="secretaria" src="../images/logos/clientsNoBc/secretaria-removebg.png" width={150}></img>
                </div>
                <div className="client">
                    <img alt="tura" src="../images/logos/clientsNoBc/cityConstrucciones-removebg.png" width={150}></img>
                </div>
                <div className="client">
                    <img alt="enac" src="../images/logos/enac.png" width={150}></img>
                </div>
            </div>
        </section>
    )
}